
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[slugCoach]",
      function () {
        return require("private-next-pages/coaches/[slugCoach]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[slugCoach]"])
      });
    }
  